import type { Product } from './product';

export const beverages: Product[] = [
    {
        ProductID: 1,
        ProductName: 'Tea',
        Description: 'Tea is an aromatic beverage...',
    },
    {
        ProductID: 2,
        ProductName: 'Coffee',
        Description: 'Coffee is a brewed drink prepared from roasted coffee beans...',
    },
    {
        ProductID: 3,
        ProductName: 'Liquor',
        Description: 'Liquor is an alcoholic drink...',
    },
    {
        ProductID: 4,
        ProductName: 'Beer',
        Description: 'Beer is one of the oldest and most widely consumed drinks in the world...',
    },
    {
        ProductID: 5,
        ProductName: 'Milk',
        Description: 'Milk is a nutrient-rich, white liquid food produced by...',
    },
    {
        ProductID: 6,
        ProductName: 'Juice',
        Description: 'Juice is a drink made from the extraction...',
    },
    {
        ProductID: 7,
        ProductName: 'Hot chocolate',
        Description: 'Hot chocolate, also known as drinking chocolate, cocoa, and as chocolate...',
    },
    {
        ProductID: 8,
        ProductName: 'Wine',
        Description: 'Wine is an alcoholic drink typically made from fermented grapes...',
    },
    {
        ProductID: 9,
        ProductName: 'Kombucha',
        Description: 'Kombucha is a fermented, slightly alcoholic, lightly effervescent...',
    },
];
